import { type FC, type ComponentProps, lazy } from 'react';

const SupportChatRoot = lazy(() =>
    import(/* webpackChunkName: "SupportChatRoot" */ './SupportChatRoot.tsx').then(mod => ({
        default: mod.SupportChatRoot,
    }))
);

const SupportChatRootLazy: FC<ComponentProps<typeof SupportChatRoot>> = props => (
    <SupportChatRoot {...props} />
);

export { SupportChatRootLazy };
